export const MIN_TERM_LENGTH = 2;
export const MATCH_LIMIT = 500;

export type SearchMatch = { page: number; ordinal: number };

export type SearchablePage = {
  getTextContent: () => Promise<{ items: ReadonlyArray<object> }>;
};

export type SearchableDocument = {
  numPages: number;
  getPage: (pageNumber: number) => Promise<SearchablePage>;
};

export const normalizeTerm = (raw: string): string => raw.trim().toLowerCase();

export async function findMatches(
  doc: SearchableDocument,
  rawTerm: string,
  isCancelled: () => boolean,
): Promise<{ matches: SearchMatch[]; truncated: boolean; cancelled: boolean }> {
  const term = normalizeTerm(rawTerm);
  const matches: SearchMatch[] = [];
  if (term.length < MIN_TERM_LENGTH) {
    return { matches, truncated: false, cancelled: false };
  }

  for (let pageNumber = 1; pageNumber <= doc.numPages; pageNumber += 1) {
    if (isCancelled()) {
      return { matches: [], truncated: false, cancelled: true };
    }
    const page = await doc.getPage(pageNumber);
    const { items } = await page.getTextContent();
    let ordinal = 0;
    for (const item of items) {
      const text = (item as { str?: unknown }).str;
      if (typeof text === 'string' && text.toLowerCase().includes(term)) {
        if (matches.length === MATCH_LIMIT) {
          return { matches, truncated: true, cancelled: false };
        }
        matches.push({ page: pageNumber, ordinal });
        ordinal += 1;
      }
    }
  }
  if (isCancelled()) {
    return { matches: [], truncated: false, cancelled: true };
  }
  return { matches, truncated: false, cancelled: false };
}

export const MATCH_CLASS = 'irm-match';
export const ACTIVE_MATCH_CLASS = 'irm-match-active';

export function markMatches(
  container: HTMLElement,
  rawTerm: string,
  activeOrdinal: number | undefined,
): HTMLElement | undefined {
  const term = normalizeTerm(rawTerm);
  let active: HTMLElement | undefined;
  let ordinal = 0;
  container.querySelectorAll<HTMLElement>('span:not(.markedContent)').forEach((span) => {
    span.classList.remove(MATCH_CLASS, ACTIVE_MATCH_CLASS);
    if (term.length < MIN_TERM_LENGTH) {
      return;
    }
    const text = span.textContent?.toLowerCase() ?? '';
    if (!text.includes(term)) {
      return;
    }
    span.classList.add(MATCH_CLASS);
    if (ordinal === activeOrdinal) {
      span.classList.add(ACTIVE_MATCH_CLASS);
      active = span;
    }
    ordinal += 1;
  });
  return active;
}
